module.exports = __webpack_public_path__ + "img/customer-icon.db9d5540.svg";